import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getEstimateById, createEstimate } from '../../services/estimate'

export const getEstimateByIdAction = createAsyncThunk('estimates/getById', async ({ id }, { rejectWithValue }) => {
  try {
    const data = await getEstimateById(id)

    return data.data
  } catch (e) {
    return rejectWithValue(e.response.data)
  }
})

export const createEstimateAction = createAsyncThunk(
  'estimates/create',
  async ({ data = {}, file }, { rejectWithValue }) => {
    try {
      const formData = new FormData()
      formData.append('data', JSON.stringify(data))
      formData.append('files.file', file, file.name)
      const response = await createEstimate({
        data: formData,
      })

      return response.data
    } catch (e) {
      return rejectWithValue(e?.response ? e?.response?.data : e?.message)
    }
  }
)

export const estimateSlice = createSlice({
  name: 'estimate',
  initialState: {
    estimate: null,
    estimates: [],
    pagination: {},
    isFetching: false,
    isSuccess: false,
    isAddSuccess: false,
    isError: false,
    errorMessage: '',
  },
  reducers: {
    clearState: (state) => {
      state.isError = false
      state.isSuccess = false
      state.isFetching = false
      state.isAddSuccess = false

      return state
    },
  },
  extraReducers: {
    [getEstimateByIdAction.fulfilled]: (state, data) => {
      state.estimate = data.payload
      state.isFetching = false
      state.isSuccess = true
      return state
    },
    [getEstimateByIdAction.rejected]: (state, { payload }) => {
      state.isFetching = false
      state.isError = true
      state.errorMessage = payload.message
    },
    [getEstimateByIdAction.pending]: (state) => {
      state.isFetching = true
    },
    [createEstimateAction.fulfilled]: (state, data) => {
      // state.estimate = data.payload.data
      state.isFetching = false
      state.isAddSuccess = true
      return state
    },
    [createEstimateAction.rejected]: (state, { payload }) => {
      state.isFetching = false
      state.isError = true
      state.errorMessage = payload.message
    },
    [createEstimateAction.pending]: (state) => {
      state.isFetching = true
    },
  },
})

export const { clearState } = estimateSlice.actions

export const estimateSelector = (state) => state.estimate
